import Colors from "../../../global/Colors";

export const FilterListConfig = [
  {
    fieldName: "document_type",
    title: "Document Type",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Document Type",
    dashboardWidgetSelections: [],
    currentValue: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `field_options/?content_type=document&field_name=document_type&flat=true&limit=100&`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "source",
    title: "Source",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Source",
    dashboardWidgetSelections: [],
    currentValue: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `field_options/?content_type=document&field_name=source&flat=true`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "related_provider",
    title: "Related Provider",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Related Provider",
    dashboardWidgetSelections: [],
    currentValue: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `core/dynamic-options/providers/`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "checked",
    title: "Checked",
    filterType: "SearchOptionGroup",
    currentValue: null,
    customFalseLabel: null,
    customTrueLabel: null,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.sky[500],
      label: "",
    },
  },
  {
    fieldName: "approved",
    title: "Approved",
    filterType: "SearchOptionGroup",
    currentValue: null,
    customFalseLabel: null,
    customTrueLabel: null,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.sky[500],
      label: "",
    },
  },
  {
    fieldName: "created_by",
    title: "Created By",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Created By",
    dashboardWidgetSelections: [],
    currentValue: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `core/dynamic-options/assignable-users/`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "created_at",
    title: "Created At",
    filterType: "DateRange",
    currentValue: {
      __gte: undefined,
      __lte: undefined,
    },
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
];

export const FilterClient = {
  fieldName: "case",
  title: "Client",
  filterType: "MultiSelectSearch",
  searchTitle: "Search Client",
  dashboardWidgetSelections: [],
  currentValue: [],
  orderingVal: "order",
  nameKey: "label",
  valueKey: "key",
  apiUrl: `core/dynamic-options/cases/`,
  permission: "",
  activeChip: {
    isActive: false,
    color: Colors.gray[400],
    label: "",
  },
};
